var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-menu',{attrs:{"default-active":this.$route.path,"mode":"horizontal","text-color":"#544646","active-text-color":"#fb3434"},on:{"select":_vm.handleSelect}},_vm._l((_vm.navList),function(item,i){return _c('el-menu-item',{key:i,attrs:{"index":item.path}},[_vm._v(_vm._s(item.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }